import React from "react";
import { Phone } from "lucide-react";

const StickyCallBar = ({ show = true }) => {
  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-red-600 shadow-[0_-4px_20px_rgba(220,38,38,0.4)] pb-[env(safe-area-inset-bottom)]">
      <div className="max-w-3xl mx-auto px-3 py-2.5 flex items-center justify-between gap-2 min-h-[56px]">
        <a
          href="tel:112"
          className="flex-1 flex items-center justify-center gap-2 bg-white text-red-700 font-bold text-sm rounded-lg py-3 px-3 transition-transform"
        >
          <Phone size={18} className="animate-pulse" />
          <span>112 ERSS</span>
        </a>
        <a
          href="tel:108"
          className="flex-1 flex items-center justify-center gap-2 bg-white/20 text-white font-bold text-sm rounded-lg py-3 px-3 transition-transform border border-white/30"
        >
          <Phone size={16} />
          <span>108</span>
        </a>
        <a
          href="tel:100"
          className="flex-1 flex items-center justify-center gap-2 bg-white/20 text-white font-bold text-sm rounded-lg py-3 px-3 transition-transform border border-white/30"
        >
          <Phone size={16} />
          <span>100</span>
        </a>
      </div>
    </div>
  );
};

export default StickyCallBar;
